import * as React from "react"
export const IconStrokeDashed = (props) => {
    const fill = props?.fill || '#202020';
    return <svg width="31" height="30" viewBox="0 0 31 30" xmlns="http://www.w3.org/2000/svg">
        <path d="m6.487 24 18-18" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeDasharray="4 4" />
    </svg>
}
export default IconStrokeDashed;